import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    detailDialogVisible: false,
    auditDetail: {}
  },
  getters: {},
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload;
    }
  },
  actions: {
    list({ commit }, query) { // eslint-disable-line
      api.getLimitSwitchList(query).then(({ data }) => {
        if(data=='没有数据'){
          commit('setAuditList',[])
        }else{
          commit('setAuditList', data);
        }
        
      });
    },
    deleteLimit(context, data) {
     return api.deleteOtcLimit(data);
    }
  }
};

appStore.registerModule('otcBuyLimit', store);
